import { DataTableSearchService } from "aes-datatables";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { SenetData } from "aes-datatables";
import { Injectable } from "@angular/core";
import { CRUDService, Message } from "aes-common";

export interface UserAPIKey {
    apikey: string;
    username: string;
    acctId: number;
    creationDate: string;
    apiKeyId: string;
}
@Injectable()
export class AESUserAPIKeysService implements DataTableSearchService<UserAPIKey>, CRUDService<UserAPIKey>{

    constructor(private http: HttpClient) { }

    create(object: UserAPIKey): Observable<Message> {
        const href = 'users/apikeys';
        var requestUrl = `${href}`

        return this.http.post<Message>(requestUrl, object);
    }
    edit(object: UserAPIKey): Observable<Message> {
        const href = 'users/apikeys';
        var requestUrl = `${href}`

        return this.http.put<Message>(requestUrl, object);
    }
    delete(object: UserAPIKey): Observable<Message> {
        const href = 'users/apikeys';
        var params = new HttpParams().set("apikey", object.apikey);
        var requestUrl = `${href}`

        return this.http.delete<Message>(requestUrl, {
            params : params
        });
    }

    search(sort: string, order: string, page: number, search: string, limit: number, customFilter: any): Observable<SenetData<UserAPIKey>> {
        const href = 'users/apikeys';
        var offset = page * limit;
        var requestUrl = `${href}`;
        var params = new HttpParams();
        if(sort != undefined && sort != ""){
            params = params.set("sort", sort);
        }
        if(!isNaN(limit)){
            params = params.set("limit", limit.toString());
        }
        if(order != undefined){
            params = params.set("sortDir", order);          
        }
        if(!isNaN(offset)){
            params = params.set("offset", offset.toString());
        }
        if (search != undefined && search != "") {
            params = params.set("search", search);
        }

        return this.http.get<SenetData<UserAPIKey>>(requestUrl, {
            params : params
        });
    }
}